import { useRouter } from 'next/router';
import React from 'react';
import { useTranslation } from '../i18n';
import { MeetingRole } from '../interfaces';
import { defaultHeaderProps } from '../utils/htmlHeader';
import { isEmbeddedInStreamingStudio } from '../utils/streamingstudio';
import {
  getParentWindowMeetingRole,
  isParentWindowInMeeting
} from '../utils/window';
import HTMLHeader, { HeaderProps } from './HTMLHeader';
import PopupStyles from './PopupStyles';
import PreventMobileZoomContainer from './PreventMobileZoomContainer';

interface ILayoutProps {
  children: React.ReactNode;
  headerProps?: HeaderProps;
}

const Layout: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const router = useRouter();
  const { i18n } = useTranslation();
  const isRtl = i18n?.language === 'ar';
  const language = (router.query?.language as string) || 'en';
  React.useEffect(() => {
    let classList = '';

    if (isEmbeddedInStreamingStudio()) {
      classList = 'ssp-embed';
    }

    if (isParentWindowInMeeting()) {
      const role = getParentWindowMeetingRole();
      classList = classList + ' in-meeting';
      if (role === MeetingRole.ADVISOR) {
        classList = classList + ' is-presenter';
      } else {
        classList = classList + ' is-client';
      }
    }

    if (classList.length) {
      document.body.className = classList;
    }
    i18n?.changeLanguage(language);
    
    i18n?.reloadResources?.(language, ['common', 'vb']).catch((e) => {
      console.log('failed to reload language', e);
    });
  }, []);

  return (
    <PreventMobileZoomContainer>
      <div className={`wrapper ${i18n.language}${isRtl ? ' isRtl' : ''}`}>
        <HTMLHeader {...(props.headerProps || defaultHeaderProps)} />
        <PopupStyles />
        <div className="content-wrapper">{props.children}</div>
      </div>
    </PreventMobileZoomContainer>
  );
};

export default Layout;
